import React from "react";
import { Card } from "flowbite-react";
import { ArrowRight } from "lucide-react";

export default function Assessments() {
  const exams = [
    {
      name: "Psychometric Test",
      desc: "Comprehensive competency mapping and career direction tool to assess your strengths and match them to the right career path.",
      link: "/competency-assessment", 
    },
    {
      name: "CAT",
      desc: "Common Admission Test for top B-schools in India. Evaluate your quantitative, verbal, and logical reasoning skills.",
      link: "https://unithink-assessments.netlify.app/", // replace with your actual CAT link
    },
    {
      name: "GMAT",
      desc: "Graduate Management Admission Test for global MBA programs. Test your analytical writing and problem-solving ability.",
      link: "https://unithink-assessments.netlify.app/", // replace with your actual GMAT link
    },
    {
      name: "GRE",
      desc: "Graduate Record Examination for MS, MBA, and PhD programs. Assess your verbal reasoning and analytical skills.",
      link: "https://unithink-assessments.netlify.app/", // replace with your actual GRE link
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-6">
      <h1 className="text-4xl font-bold text-center mb-10 text-gray-800">
        Explore Our Assessments
      </h1>
      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {exams.map((exam) => (
          <Card
            key={exam.name}
            className="hover:shadow-lg transition-shadow duration-300 rounded-2xl cursor-pointer"
            onClick={() => window.open(exam.link, "_blank")}
          >
            <h2 className="text-2xl font-semibold text-blue-700 mb-2">
              {exam.name}
            </h2>
            <p className="text-gray-600 mb-4">{exam.desc}</p>
            <div className="flex items-center text-blue-600 font-medium">
              <span>Visit Assessment</span>
              <ArrowRight className="ml-2 w-4 h-4" />
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
